/* eslint-disable */
import { useEffect, useState } from "react";

import Select from "react-select";

interface SelectInputProps {
  id: string;
  onChange: (updatedData: Option | null) => void;
  options: Option[];
  placeholder?: string;
  preSelectedOption: Option | null;
  required?: boolean;
  tabIndex?: number;
}

interface Option {
  value: number;
  label: string;
}

const SelectInput = ({
  id,
  onChange,
  options,
  placeholder,
  preSelectedOption,
  required,
  tabIndex
}: SelectInputProps) => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(
    preSelectedOption || null
  );

  useEffect(() => {
    setSelectedOption(preSelectedOption);
  }, [preSelectedOption]);

  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    onChange(option);
  };

  return (
    <div id={`react-select-${id}`}>
      <Select
        classNamePrefix="react-select"
        classNames={{ control: (_) => "form-control" }}
        inputId={id}
        name={id}
        options={options}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        styles={{
          option: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#007bff" : "transparent",
            color: state.isSelected ? "#fff" : "#333",
            "&:hover": {
              backgroundColor: "#007bff",
              color: "#fff",
            },
          }),
        }}
        tabIndex={tabIndex}
        value={selectedOption}
      />
    </div>
  );
};

export default SelectInput;
